import { LockMinusOutlineIcon } from './LockMinusOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 073A5F44-B5D1-4112-AD20-1F86F94ADF60
 * name lock-minus-outline
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-minus-outline.svg
 * tags
 * - Lock 
 */
export const PasswordMinusOutlineIcon = LockMinusOutlineIcon;
export default PasswordMinusOutlineIcon